
export default {
  name: 'CompanyCorporateActions',
  props: {
    corporateActions: {
      type: Array
    }
  }
}
